import { render } from "./LinkedInFormInput.vue?vue&type=template&id=98df1af8&scoped=true&ts=true"
import script from "./LinkedInFormInput.vue?vue&type=script&lang=ts"
export * from "./LinkedInFormInput.vue?vue&type=script&lang=ts"

import "./LinkedInFormInput.vue?vue&type=style&index=0&id=98df1af8&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98df1af8"]])

export default __exports__